import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addInspection } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddInspection(orderId: string) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (message: string) => {
      if (!accessToken) throw new Error("Not authenticated")
      return addInspection(orderId, message, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", orderId] })
      queryClient.invalidateQueries({ queryKey: ["admin-order-detail", orderId] })
      queryClient.invalidateQueries({ queryKey: ["seller-order-detail", orderId] })
    },
  })
}
